<mat-form-field fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent" style="padding-top: 0.75em;">
  <textarea matInput hidden></textarea>
  <mat-slide-toggle           
          class="example-margin"
          [color]="color"
          [formControlName]="configData.name"
          [required]="configData.required"
          (change) = "manageToggleData($event)"          
          >
    {{configData.label}}
  </mat-slide-toggle>
</mat-form-field>
